import React, { useState, useEffect} from "react";
import axios from 'axios';
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Sidebar from "../../components/sidebar";
import {Col,Row} from "reactstrap";
import { Alert } from "react-bootstrap";

const url = "https://api.mrcirp.com/public/userpanel";

const DatosUsuarios = () => {

/////////////Mostrar datos//////////////////////////////////
const [users, setUsers] = useState([]);
const [data, setdata] = useState([]);
const [editing, setEditing] = useState(false);
const [formData, setFormData] = useState({
  correo: '',
  tlfwhatsapp: ''
});
const [loading, setLoading] = useState(false);
const [success, setSuccess] = useState(false);
const [error, setError] = useState(null);


useEffect(() => {
  const loginUserJSON = window.localStorage.getItem('loginUser')
  if(loginUserJSON){
    const user= JSON.parse(loginUserJSON)
    setUsers(user);
  }
 }, []);
  
 useEffect(() => {
    axios.get(url+'/'+users.id).then(res => {
    if(res.data[0]) {
    setdata(res.data[0]);
    setFormData({
      correo: res.data[0].correo || '',
      tlfwhatsapp: res.data[0].tlfwhatsapp || ''
    });
    }
   });
 }, [users]);

 const handleChange = (e) => {
   const { name, value } = e.target;
   setFormData(prev => ({
     ...prev,
     [name]: value
   }));
 };

 const handleEdit = () => {
   setEditing(true);
   setSuccess(false);
   setError(null);
 };

 const handleCancel = () => {
   setEditing(false);
   setFormData({
     correo: data.correo || '',
     tlfwhatsapp: data.tlfwhatsapp || ''
   });
   setError(null);
 };

 const handleSubmit = async (e) => {
   e.preventDefault();
   setLoading(true);
   setError(null);
   setSuccess(false);
   
   try {
     const updateUrl = "https://api.mrcirp.com/public/userpaneleditar";
     const response = await axios.put(`${updateUrl}/${users.id}`, {
       correo: formData.correo,
       tlfwhatsapp: formData.tlfwhatsapp
     });
     
     if (response.data) {
       setSuccess(true);
       setEditing(false);
       // Actualizar los datos locales
       setdata(prev => ({
         ...prev,
         correo: formData.correo,
         tlfwhatsapp: formData.tlfwhatsapp
       }));
       // Actualizar también en localStorage si es necesario
       const updatedUser = { ...users, correo: formData.correo, tlfwhatsapp: formData.tlfwhatsapp };
       window.localStorage.setItem('loginUser', JSON.stringify(updatedUser));
       setUsers(updatedUser);
       
       setTimeout(() => {
         setSuccess(false);
       }, 3000);
     }
   } catch (err) {
     console.error('Error al actualizar datos:', err);
     setError(err.response?.data?.message || 'Error al actualizar los datos');
   } finally {
     setLoading(false);
   }
 };

 console.log(data);

    return (
        <div>
            <div>
                <Sidebar>
                    <Card>
                        <Card.Header className="bg-dark text-white" as="h3">Mis Datos</Card.Header>
                        <Card.Body>
                            <Card.Title>Datos personales</Card.Title>
                            <Card.Text>
                                Esta informacion fue proporcionado por el administrador al registrarlo en el sistema.
                            </Card.Text>
                            
                            {success && (
                                <Alert variant="success" className="mt-3">
                                    Datos actualizados correctamente!
                                </Alert>
                            )}
                            
                            {error && (
                                <Alert variant="danger" className="mt-3">
                                    {error}
                                </Alert>
                            )}
                            
                            {!editing && (
                                <div className="mb-3">
                                    <Button variant="primary" onClick={handleEdit}>
                                        Editar Teléfono y Correo
                                    </Button>
                                </div>
                            )}

                            <Row>
                                <Col xs={6} md={4}>
                                    <div className="form-group">
                                        <label>Codigo de usuario</label>
                                        <input
                                            className="form-control"
                                            readOnly
                                            type="text"
                                            name="codigo"
                                            value={data.id}
                                        />
                                    </div>
                                </Col>
                                <Col xs={6} md={4}>
                                    <div className="form-group">
                                        <label>Username</label>
                                        <input
                                            className="form-control"
                                            readOnly
                                            type="text"
                                            name="proveedor"
                                            value={data.username}
                                        />
                                    </div>
                                </Col>
                                <Col xs={6} md={4}>
                                    <div className="form-group">
                                        <label>Nombre usuario</label>
                                        <input
                                            className="form-control"
                                            readOnly
                                            type="text"
                                            name="usuario"
                                            value={data.nombreuser}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} md={4}>
                                <div className="form-group">
                                        <label>Status</label>
                                        <input
                                            className="form-control"
                                            readOnly
                                            type="text"
                                            name="status"
                                            value={data.status}
                                        />
                                    </div>
                                </Col>
                                <Col xs={6} md={4}>
                                    <div className="form-group">
                                        <label>Telefono</label>
                                        <input
                                            className="form-control"
                                            readOnly={!editing}
                                            type="text"
                                            name="tlfwhatsapp"
                                            value={editing ? formData.tlfwhatsapp : (data.tlfwhatsapp || '')}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </Col>
                                <Col xs={6} md={4}>
                                    <div className="form-group">
                                        <label>Correo Electronico</label>
                                        <input
                                            className="form-control"
                                            readOnly={!editing}
                                            type="email"
                                            name="correo"
                                            value={editing ? formData.correo : (data.correo || '')}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            
                            {editing && (
                                <div className="mt-4">
                                    <Button 
                                        variant="success" 
                                        onClick={handleSubmit}
                                        disabled={loading}
                                        className="me-2"
                                    >
                                        {loading ? 'Guardando...' : 'Guardar Cambios'}
                                    </Button>
                                    <Button 
                                        variant="secondary" 
                                        onClick={handleCancel}
                                        disabled={loading}
                                    >
                                        Cancelar
                                    </Button>
                                </div>
                            )}
                            
                        </Card.Body>
                    </Card>
                </Sidebar>
            </div>
        </div>
    );
};

export default DatosUsuarios;